<app-cc-form-dialog #ccForm [transPartKey]="transPartKey"
                    [loading]="formLoading" [submitted]="formSubmitted"
                    [(dialogFormVisible)]="dialogFormVisible"
                    [formConfig]="formConfig" [dialogFormTitle]="dialogFormTitle"
                    [(formRecord)]="formRecord" (onSubmitEvent)="save()"
                    [loadingProgressValue]="loadingProgressValue" [dialogClass]="'user-view-form-dialog'"
                    (dialogFormVisibleChange)="dialogFormVisible?onShow():{}; dialogFormVisibleChange.emit($event);"
></app-cc-form-dialog>

